import React, {Fragment, useState} from 'react'

const CatalogueFilter = ({title, open, children}) => {
  const [isOpen, setIsOpen] = useState(open);

  const handleClick = event => {
    setIsOpen(!isOpen)
  };

  return (
    <Fragment>
      <div className="sidebar__division-title">
        <h3>{title}</h3>
        <div className={isOpen ? 'opener-down' : 'opener-up'}
             onClick={handleClick}/>
      </div>
      {isOpen && children}
    </Fragment>
  )
};

export default CatalogueFilter
